/* eslint-disable no-mixed-spaces-and-tabs */
import { createSelector } from 'reselect';
import { initialState } from './reducer';

export const selectThermoboxesReportsContainerDomain = state =>
	state.thermoboxesReportsContainerReducer || initialState;

export const getIsThermoboxesReportsLoadingSelector = () =>
	createSelector(
		selectThermoboxesReportsContainerDomain,
		({ isThermoboxesReportsLoading }) => isThermoboxesReportsLoading,
	);

export const getThermoboxesReportsSelector = () =>
	createSelector(selectThermoboxesReportsContainerDomain, ({ thermoboxesReports }) => {
		return thermoboxesReports;
	});

export const getPaginationSelector = () =>
	createSelector(selectThermoboxesReportsContainerDomain, ({ pagination }) => {
		if (!pagination || pagination?.total === 0) {
			return null;
		}

		return {
			currentPage: pagination.current_page,
			totalPages: pagination.last_page,
			perPage: pagination.per_page,
			total: pagination.total,
			from: pagination.current_page * pagination.per_page - (pagination.per_page - 1),
			to:
				pagination.current_page === pagination.last_page
					? pagination.total
					: pagination.current_page * pagination.per_page,
			isNextItem: true,
			isPrevItem: true,
			isLastItem: false,
			isFirstItem: false,
		};
	});

export const getThermoboxesOptionsSelector = () =>
	createSelector(selectThermoboxesReportsContainerDomain, ({ thermoboxes }) => thermoboxes);

export const getIsThermoboxesLoadingSelector = () =>
	createSelector(selectThermoboxesReportsContainerDomain, ({ isThermoboxesLoading }) => isThermoboxesLoading);

export const getModesOptionsSelector = () =>
	createSelector(selectThermoboxesReportsContainerDomain, ({ modes }) => modes);

export const getIsModesLoadingSelector = () =>
	createSelector(selectThermoboxesReportsContainerDomain, ({ isModesLoading }) => isModesLoading);
